/**
 * VISUAL-SEARCH-001-R4A / SEARCH-PERF-169A-R1 —
 * Canonical search-session fields (never one mutable query for all roles).
 */
export type SearchSessionSnapshot = {
  sessionId: number;
  draftQuery: string;
  submittedQuery: string;
  suggestionQuery: string;
  activeRequestId: number;
  refineMode: boolean;
};

let session: SearchSessionSnapshot = {
  sessionId: 1,
  draftQuery: "",
  submittedQuery: "",
  suggestionQuery: "",
  activeRequestId: 0,
  refineMode: false,
};

export function getSearchSession(): Readonly<SearchSessionSnapshot> {
  return session;
}

/** Bottom nav → Пошук / clear / route reset. */
export function beginNewSearchSession(): number {
  session = {
    sessionId: session.sessionId + 1,
    draftQuery: "",
    submittedQuery: "",
    suggestionQuery: "",
    activeRequestId: 0,
    refineMode: false,
  };
  return session.sessionId;
}

export function setSearchDraftQuery(q: string): void {
  session = { ...session, draftQuery: q };
}

export function setSearchSuggestionQuery(q: string): void {
  session = { ...session, suggestionQuery: q };
}

export function nextSearchRequestId(): number {
  session = { ...session, activeRequestId: session.activeRequestId + 1 };
  return session.activeRequestId;
}

export function commitSubmittedQuery(q: string): void {
  const trimmed = String(q ?? "").trim();
  session = {
    ...session,
    submittedQuery: trimmed,
    draftQuery: "",
    suggestionQuery: "",
    refineMode: false,
  };
}

/** Explicit Edit/Refine Search only. */
export function enterRefineSearch(prefillSubmitted: boolean): string {
  const prefill = prefillSubmitted ? session.submittedQuery : "";
  session = {
    ...session,
    refineMode: true,
    draftQuery: prefill,
    suggestionQuery: "",
  };
  return prefill;
}

export function clearSearchDraft(): void {
  session = { ...session, draftQuery: "", suggestionQuery: "" };
}
